export enum UserProceedWithUpdateResponse {
  UNKNOWN = 0,
  NO = 1,
  YES = 2,
  DEFER = 3
}
